import type { ClientError } from '@tribeplatform/gql-client/lib'
import type {
  Action,
  MutationUpsertExtraPropertyArgs,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import {
  getAuthMemberKey,
  getAuthTokenKey,
} from '../../utils/keys/authToken.keys.js'
import { getNetworkKey } from '../../utils/keys/network.key.js'
import { getExtraPropertiesKey } from '../../utils/keys/properties.keys.js'

export const useUpsertExtraProperty = (options?: {
  useMutationOptions?: UseMutationOptions<
    Action,
    ClientError,
    MutationUpsertExtraPropertyArgs
  >
}) => {
  const { useMutationOptions } = options || {}
  const queryClient = useQueryClient()
  const { client } = useTribeClient()

  return useMutation<Action, ClientError, MutationUpsertExtraPropertyArgs>(
    input => client.upsertExtraProperties(input),
    {
      onSettled: () => {
        queryClient.invalidateQueries(getNetworkKey())
        queryClient.invalidateQueries(getAuthMemberKey())
        queryClient.invalidateQueries(getAuthTokenKey())
        queryClient.invalidateQueries(getExtraPropertiesKey())
      },
      ...useMutationOptions,
    },
  )
}
